import { differenceInSeconds } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { secondsToHumanReadable } from '@/utils/datetime'
import AlertContainer from './AlertContainer'
import { useCurrentTime } from '@/stores/currentTime'
import { isTimeToDropoffAlertVisible, isTimeToDropoffDetailedMessage } from '../dropoffAlertRules'

const TimeToDropoffAlert = ({
  dropoffStartDate,
  driveDuration,
  scheduledEnd,
}: {
  dropoffStartDate: Date | undefined
  driveDuration?: number
  scheduledEnd?: string
}) => {
  const { t, i18n } = useTranslation('navigation')
  const now = useCurrentTime(1000)
  const locale = i18n.language || 'cs'

  if (!dropoffStartDate) return null

  const secondsToDropoff = differenceInSeconds(dropoffStartDate, now)
  if (!isTimeToDropoffAlertVisible(secondsToDropoff)) {
    return null
  }

  const leaveInString = secondsToHumanReadable(secondsToDropoff)
  const useDetailedMessage = isTimeToDropoffDetailedMessage(secondsToDropoff)

  let message = ''

  if (useDetailedMessage) {
    const endTimeStr = scheduledEnd
      ? new Date(scheduledEnd).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
      : ''

    const driveMinutes = driveDuration ? Math.ceil(driveDuration / 60) : 0

    message = t('garageCountdownDetailed', {
      defaultValue: `Shift ends ${endTimeStr}. Depart in ${leaveInString}`,
      end: endTimeStr,
      drive: driveMinutes,
      leaveIn: leaveInString,
    })
  } else {
    message = t('goToDropoffIn', { time: leaveInString })
  }

  return (
    <AlertContainer
      type="alert"
      alertColor="teal"
      alertText={message}
      position="bottom"
      opacity="medium"
      noOverlay
      height="tiny"
      textSize="var(--spacing-lg)"
    />
  )
}

export default TimeToDropoffAlert
